import { INote } from "models/notes";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useEffect, useState } from "react";


type UseWorkItemNotesSignature = (id: number | string | undefined, draft?: boolean)=> UseWorkItemNotesResult;

type UseWorkItemNotesResult = [
    INote[],
    number,
    () => void,
    boolean,
    string | null
];

const makeWorkItemNotesUrl = (id: number | string | undefined, draft?: boolean) => draft 
    ? `/api/v3/drafts/workitems/${id}/notes`
    : `/api/v3/workitems/${id}/notes`;

const useWorkItemNotes: UseWorkItemNotesSignature = (workItemId: number | string | undefined, draft?: boolean) => {

    const [ refreshMarker, setRefreshMarker ] = useState<number>(0);

    const [ result, setResult ] = useState<INote[]>([]);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);

    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const handleRefresh = () => setRefreshMarker(refreshMarker + 1);

    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            if (workItemId === 0)
                return;
            if (user && user.access_token) {
                setLoading(true);
                try {
                    const urlRoot = makeWorkItemNotesUrl(workItemId, draft);

                    const resp = await fetcher(urlRoot, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        setError(resp.statusText);
                    }

                    const data = await resp.json() as INote[];

                    setResult(data);
                } catch (err) {
                    
                } finally {
                    if (!controller.signal.aborted)
                        setLoading(false);
                }
            }
        })();

        return () => controller.abort();
    }, [ user, workItemId, refreshMarker ]);

    return [
        result,
        result.length,
        handleRefresh,
        loading,
        error
    ]
};

export default useWorkItemNotes;